import { render, staticRenderFns } from "./TabOpleveringen.vue?vue&type=template&id=3a8b3f6c"
import script from "./TabOpleveringen.vue?vue&type=script&lang=js"
export * from "./TabOpleveringen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports